import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import proposalsApi from '../../../APIs/proposals';
import { JobInformation } from '../../../components/ClientCreatedJobDetails';
import { TechnicalNote } from '../../../components/Proposals/ProposalForEscapePlan';
import {
  Accordion,
  Button,
  Divider,
  Loader,
  NavigateBack,
  Tag,
  Timeline,
  Typography,
} from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import {
  humanReadableDate,
  humanReadableDateWithTime,
  requestAPI,
} from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';
import { ActionsContainer } from '../ViewProposal/style';
import { IndividualTechnicianProposalStyled } from './style';

type event = {
  startingDate?: string;
  endDate?: string;
};

const JobProposals = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { proposalId } = useParams();

  const proposalsListDetails = useSelector(
    (state: RootState) => state.proposalsListDetails
  );

  const getProposalsById = async (id: string) => {
    try {
      setLoading(true);
      const proposals = await requestAPI(proposalsApi.getProposalById(id));
      console.log(proposals);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (proposalId) {
      getProposalsById(proposalId);
    }
  }, [proposalId]);

  const events = (_props: event) => [
    {
      date: humanReadableDate(_props.startingDate) || '',
      title: 'Starting Date',
    },
    {
      date: humanReadableDate(_props.endDate) || '',
      title: 'End Date',
    },
  ];
  const handleViewProposal = (routeId: string) => {
    navigate(routeId);
  };

  const createAtDate =
    typeof proposalsListDetails.createdAt === 'string'
      ? humanReadableDateWithTime(proposalsListDetails.createdAt)
      : '';
  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      {loading ? (
        <Loader
          type="spinner"
          style={{ display: 'flex', justifyContent: 'center', width: '100%' }}
        />
      ) : (
        <div className="contents">
          <IndividualTechnicianProposalStyled>
            <Typography
              variant="heading"
              style={{ marginBottom: '20px' }}
              strong
            >
              Job Details
            </Typography>
            <JobInformation
              jobCreatedAt={createAtDate}
              jobTitle={proposalsListDetails.technicianJobId?.jobTitle || ''}
              notes={proposalsListDetails.technicianJobId?.notes || ''}
            />
          </IndividualTechnicianProposalStyled>
          <Divider spaceY="20px" />
          <Typography variant="title">PROPOSALS</Typography>
          {Array.isArray(proposalsListDetails.proposals)
            ? proposalsListDetails.proposals.map((proposals, index) => {
                console.log(proposals);
                return (
                  <Accordion
                    key={index}
                    items={[
                      {
                        key: '1',
                        content: (
                          <div>
                            <IndividualTechnicianProposalStyled>
                              <Timeline events={events(proposals)} />
                              <Divider spaceY="20px" />
                              <TechnicalNote notes={proposals.notes} />
                              <ActionsContainer>
                                <Button
                                  variant="secondary"
                                  onClick={() =>
                                    handleViewProposal(proposals._id)
                                  }
                                >
                                  View Details
                                </Button>
                              </ActionsContainer>
                            </IndividualTechnicianProposalStyled>
                          </div>
                        ),
                        title: (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              width: '100%',
                            }}
                          >
                            <Typography
                              variant="title"
                              fontColor="secondary"
                              strong
                            >
                              {typeof proposals.createdBy === 'string'
                                ? ''
                                : proposals.createdBy?.emailAddress}
                            </Typography>
                            <div>
                              {(proposals.proposalStatus === 'ACCEPT' && (
                                <Tag type="success">ACCEPTED</Tag>
                              )) ||
                                (proposals.proposalStatus === 'DECLINE' && (
                                  <Tag type="danger">DECLINED</Tag>
                                )) ||
                                (proposals.proposalStatus === 'REJECT' && (
                                  <Tag type="danger">REJECTED</Tag>
                                )) ||
                                (proposals.proposalStatus ===
                                  'PROPOSAL-CREATED' && (
                                  <Tag type="warning">PENDING</Tag>
                                )) ||
                                (proposals.proposalStatus === 'PENDING' && (
                                  <Tag type="warning">PENDING</Tag>
                                ))}
                            </div>
                          </div>
                        ),
                        titleFontVariant: 'title',
                        fontColor: 'secondary',
                      },
                    ]}
                  />
                );
              })
            : []}
        </div>
      )}
    </ViewJobContainerStyled>
  );
};

export default JobProposals;
